import * as Ariakit from '@ariakit/react';
import styled from 'styled-components';
import { zIndexModal } from '../../constants';
export const Tooltip = styled.div `
  width: auto;
  min-width: 225px;
  max-width: 275px;
  opacity: 0;
  transform: ${o => (o.placement.startsWith('top') ? `translateY(4px)` : `translateY(-4px)`)};
  transition: 0.125s ease-out all;
  background: white;
  border: 1px solid ${o => o.theme.color.deprecated.stoneLight};
  border-radius: 3px;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  z-index: ${zIndexModal + 1};
  &[data-enter='true'] {
    opacity: 1;
    transform: translateY(0);
  }
  padding: ${o => o.theme.spacing(4)};
`;
export const DialogOverlay = styled.div `
  background-color: rgba(0, 0, 0, 0.5);
  z-index: ${zIndexModal};
  opacity: 0;
  transition: 0.175s ease-out opacity;
  pointer-events: none;
  &[data-enter='true'] {
    pointer-events: all;
    opacity: 1;
  }
`;
export const TooltipArrow = styled(Ariakit.TooltipArrow) `
  > svg {
    fill: white;
  }
`;
export const Dialog = styled.div `
  position: fixed;
  box-sizing: border-box;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: ${o => o.theme.spacing(6, 4, 10)};
  background: white;
  z-index: ${zIndexModal + 1};
  transition: 0.125s ease-out transform;
  transform: translateY(100%);
  &[data-enter='true'] {
    transform: translateY(0);
  }
`;
export const DialogInner = styled.div `
  position: relative;
  display: flex;
  flex-direction: column;
`;
export const DialogDismiss = styled(Ariakit.DialogDismiss) `
  align-self: flex-end;
`;
//# sourceMappingURL=styles.js.map